import _ from 'lodash'

/**
 * Helps with determining if a field is editable in different dataset views.
 *
 * @param {Object} dataset
 */

class EditableFieldChecker {

	constructor(options = {}) {
		this.dataset = options.dataset
	}

	hasPrimaryKey() {
		const pkField = this.dataset.get('primaryKeyFieldId')
		const pkColumn = _.get(this.dataset.get('dataSourceMetadata'), 'primaryKey')
		return pkField != null || pkColumn != null
	}

	editableAllowed() {
		// editable fields are allowed without a PK on datasets with no data source
		if (this.dataset.hasNoDataSource()) return true
		return this.hasPrimaryKey()
	}

	isManualField(field) {
		const fieldType = _.get(field, 'fieldType')
		return fieldType === 'manual'
	}

	isNotEditableField(field) {
		// #42214 the "Allow Values to be Overridden" checkbox should be hidden
		// for calculated fields and for data clusters
		const fieldType = _.get(field, 'fieldType')
		const isNotEditableField = fieldType === 'calculated' || fieldType === 'cluster'
		return isNotEditableField
	}

	/**
	 * @returns {{editable: boolean, disabled: boolean}}
	 */
	getDefaultEditableAndEditableDisabled(field) {
		let editable = false
		let disabled = true
		if (!this.editableAllowed()) return { editable, disabled }
		const editingEditableField = _.get(field, 'editable', false)
		// #45813 always allow editing on manual fields
		// If you toggle a different field type after "manual" was toggled on,
		// set the "checked" property to whichever state it was in before.
		editable = editingEditableField || this.isManualField(field)
		// always disable the checkbox for manual fields
		if (!this.isManualField(field)) {
			disabled = false
		}

		return { editable, disabled }
	}

	getMessageCodeForDisabledEditable(field) {
		const { disabled } = this.getDefaultEditableAndEditableDisabled(field)
		if (!disabled) return

		let msgCode = 'datasets.fields.editable.primaryKeyRequired'
		if (!this.isManualField(field)) return msgCode

		msgCode = 'datasets.fields.editable.noDataSource.manualField'
		return msgCode
	}

}

export default EditableFieldChecker
EditableFieldChecker.__filename__ = 'datasets/edit/fields/editable-field-checker.js'
